//Library Imports
import { useSelector } from "react-redux";
import { RootState } from "../../../store/index";
import { useEffect } from "react";

//Local Imports
import Mainnav from "../../Common/Components/Mainnav";
import PublishContent from "./PublishContent";
import FloatingPopover from "../../Common/Components/FloatingPopover";
import { resetShowingNotPremiumPopup } from "modules/Publish/actions";
import Preview from "modules/Design/Shared/Preview";
import { IDesignState } from "modules/Design/Interfaces";
import { addGillRoyIcon, getPlanType, removeGillRoyIcon } from "utils";

//Style Imports
import styled from "styled-components";

const Publish: React.FC = () => {

  useEffect(() => {
    addGillRoyIcon()
    return () => {
      removeGillRoyIcon()
    };
  }, [])

  const design: IDesignState = useSelector((state: RootState) => state.design);
  const emailContent: any = useSelector((state: RootState) => state.design.data.email_html);
  const htmlContent: any = useSelector((state: RootState) => state.design.data.html);
  const cssContent: any = useSelector((state: RootState) => state.design.data.css);
  const assetType: any = useSelector((state: RootState) => state.design.data.asset_type);
  const showPopoverOnMount = getPlanType().toUpperCase() === "ENTERPRISE" ? false : true;

  return (
    <WrapperOuter>
      <Wrapper>
        <Mainnav />
        <div className="content-inner">
          <div className="designWrapper">
            <div className="preview-screen active">
              <Preview
                assetType={assetType}
                cssContent={cssContent}
                htmlContent={htmlContent}
                emailContent={emailContent}
              />
              {/* Showing popup for upgrade */}
              {showPopoverOnMount && (
                <FloatingPopover
                  isSidebar={true}
                  contentType='email'
                  showRoyIcon={false}
                  onVisibleChange={() => {
                    // * Add a logic when a user click away from the upgrade popup
                    resetShowingNotPremiumPopup();
                  }}
                  defaultVisible={showPopoverOnMount}
                />
              )}
            </div>
          </div>
        </div>
      </Wrapper>
      <PublishContent />
    </WrapperOuter>
  );
};

export default Publish;

const WrapperOuter = styled.div`
  z-index: 9;
`;

const Wrapper = styled.div`
  background-color: #fff;
  box-sizing: border-box;
  background-size: cover;
  min-height: calc(100vh - 170px);
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  /* margin-top: 120px; */
  @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
    min-height: calc(100vh - 130px);
  }
  .dark-overlay {
    background-color: rgba(0, 0, 0, 0.5);
    position: fixed;
    height: 100vh;
    width: 100%;
    z-index: 10;
  }
  .content-inner {
    display: flex;
    align-self: flex-end;
    flex-direction: column;
    background-color: #fff;
    box-sizing: border-box;
    /* width: calc(100% - 88px); */
    margin: 0 -90px;
    width: calc(100% + 180px) !important;
    float: right;
    min-height: calc(100vh - 170px) !important;
    background-color: #f9f8f6;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      /* width: calc(100% - 63px); */
      margin: 0 -65px;
      width: calc(100% + 130px) !important;
      min-height: calc(100vh - 130px) !important;
    }
  }
  .designWrapper {
    display: flex;
    flex-wrap: wrap;
    margin: 6px 10px 0 10px;
    position: relative;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      margin-top: 15px;
    }
    .preview-screen {
      position: absolute;
      top: 0px;
      left: 0px;
      width: calc(100% - 576px);
      height: calc(100vh - 160px);
      background-color: #f9f8f6;
      z-index: -999;
      display: none;
      padding-right: 15px;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        width: calc(100% - 410px);
        height: calc(100vh - 130px);
      }
      &.active {
        z-index: 9;
        display: block;
      }
    }
    .preview-wraper {
      border: 1px solid #b5c3d4;
      -webkit-box-flex: 0;
      -ms-flex: 0 0 870px;
      flex: 0 0 870px;
      max-width: 870px;
      height: calc(100vh - 120px);
      overflow: hidden;
      position: relative;
    }
    .settings-wraper {
      border: 1px solid #b5c3d4;
      margin-left: 15px;
      -webkit-box-flex: 0;
      -ms-flex: 0 0 calc(100% - 885px);
      flex: 0 0 calc(100% - 885px);
      max-width: calc(100% - 885px);
      height: calc(100vh - 120px);
      overflow: hidden;
      .scrollable {
        max-height: calc(100vh - 225px);
        overflow: auto;
        scrollbar-width: thin;
        scrollbar-color: #001760 #efefef;
        &::-webkit-scrollbar {
          width: 5px;
          height: 5px;
          border-radius: 5px;
        }
        /* Track */
        &::-webkit-scrollbar-track {
          background: #fff;
          margin-top: 10px;
          margin-bottom: 15px;
        }
        /* Handle */
        &::-webkit-scrollbar-thumb {
          background: #001760;
        }
        /* Handle on hover */
        &::-webkit-scrollbar-thumb:hover {
          background: #efefef;
        }
      }
    }
  }
`;
